import { clearLoginAsSession, isLoginAsActive, restoreMainSessionAfterLoginAs } from './loginAsSession';

export const handleError = (err, setErrors) => {
    const clearAuthState = () => {
        if (isLoginAsActive() && restoreMainSessionAfterLoginAs()) {
            return;
        }

        clearLoginAsSession();
        localStorage.removeItem('admin_id');
        localStorage.removeItem('login');
        localStorage.removeItem('token');
    };

    if (err && err.errors) {
        if (Array.isArray(err.errors) && err.errors.length > 0) {
            setErrors({ general: err.errors[0].message || "Unknown error." });
        } else if (typeof err.errors === 'object' && Object.keys(err.errors).length > 0) {
            setErrors(err.errors);
        } else {
            setErrors({ general: err.message || "An unknown error occurred." });
        }
    } else if (err && (err.message || err.statusCode)) {
        let errorMessage = "An unknown error occurred.";

        if (err.statusCode) {
            switch (err.statusCode) {
                case 400:
                    errorMessage = err.message || "Invalid request. Please check the entered data.";
                    break;
                case 401:
                    let timeLeft = 5;
                    const baseMessage = "Unauthorized access. Please log in again...";

                    setErrors({ general: `${baseMessage} ${timeLeft}` });

                    const countdownInterval = setInterval(() => {
                        timeLeft -= 1;
                        if (timeLeft > 0) {
                            setErrors({ general: `${baseMessage} ${timeLeft}` });
                        } else {
                            clearInterval(countdownInterval);
                            clearAuthState();
                            window.location.reload();
                        }
                    }, 1000);
                    break;
                case 403:
                    errorMessage = "Access denied. You do not have permission to perform this action.";
                    break;
                case 404:
                    errorMessage = "[404] Resource not found.";
                    break;
                case 422:
                    errorMessage = "Invalid data. Please check the entered information.";
                    break;
                default:
                    errorMessage = `Error ${err.statusCode}: An error occurred.`;
                    break;
            }
        } else if (err.message) {
            errorMessage = err.message;
        }

        if (err.statusCode !== 401) {
            setErrors({ general: errorMessage });
        }
    } else {
        setErrors({ general: "An error occurred while processing the request." });
    }
};
